import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'

function showBootFailure(message) {
  const root = document.getElementById('root')
  if (!root) return
  // Preserve a visible recovery UI if React never mounts or hard-crashes
  root.innerHTML = `
    <div style="min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:24px;background:var(--bg-body,#0A0A0B);color:var(--text-main,#fff);font-family:system-ui,sans-serif;text-align:center">
      <div style="font-size:15px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:var(--red,#ff0055)">Dashboard failed to start</div>
      <div style="font-size:13px;color:var(--text-muted,rgba(255,255,255,.7));max-width:420px;line-height:1.5">${message || 'An unexpected error stopped the app from loading.'}</div>
      <button type="button" onclick="location.reload()" style="background:var(--btn-bg,#00F0FF);color:var(--btn-text,#050506);border:none;border-radius:8px;padding:10px 18px;font-weight:800;font-size:13px;cursor:pointer">Reload dashboard</button>
      <a href="/pages/dashboard.php" style="font-size:12px;color:var(--blue,#00F0FF)">Open classic dashboard</a>
    </div>
  `
}

// Surface unexpected runtime errors without leaving a blank document
window.addEventListener('error', (ev) => {
  try {
    console.error('[TMR window error]', ev?.error || ev?.message)
  } catch (_) { /* noop */ }
})

window.addEventListener('unhandledrejection', (ev) => {
  try {
    console.error('[TMR unhandledrejection]', ev?.reason)
  } catch (_) { /* noop */ }
})

const el = document.getElementById('root')
if (!el) {
  document.body?.insertAdjacentHTML(
    'beforeend',
    '<p style="color:#fff;padding:24px;font-family:system-ui">Missing #root mount node.</p>',
  )
} else {
  try {
    createRoot(el).render(
      <StrictMode>
        <ErrorBoundary name="Application">
          <App />
        </ErrorBoundary>
      </StrictMode>,
    )
    // Mark successful mount so the HTML boot watchdog can stand down
    try {
      document.documentElement.dataset.tmrBooted = '1'
      window.__TMR_BOOTED__ = true
    } catch (_) { /* noop */ }
  } catch (err) {
    console.error('[TMR bootstrap]', err)
    showBootFailure(String(err?.message || err))
  }
}

// Expose for optional recovery from inline HTML watchdog
window.__TMR_SHOW_BOOT_FAILURE__ = showBootFailure
